module.exports = __webpack_public_path__ + "media/images/weather/84_night_g-a4bfc449555071f0d8a789dcafde1307.png";